import { Fragment } from 'react';
import { Stack } from '@mui/material';

import { IFormValues } from 'routes/Main/type';

import RowContainer from '../../components/RowContainer';
import RowContent from './components/RowContentSub';
import SectionTitle from '../../components/SectionTitle';
import CheckboxOne from './components/CheckboxOne';

interface Props extends IFormValues {
  disabled?: boolean;
}

const Language = (props: Props) => {
  const { disabled, getValues, setValue } = props;

  return (
    <Fragment>
      <SectionTitle title="언어" />

      <RowContainer xs={12}>
        <RowContent title="의사소통태도" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            <CheckboxOne
              i18nNullKey="ETC"
              disabled={disabled}
              i18nKey="MSE.LANGUAGE.ATTITUDE"
              values={[1, 2]}
              defaultValue={getValues('language.attitude.checked')}
              onChange={v => {
                setValue('language.attitude.checked', v);
              }}
            />
          </Stack>
        </RowContent>
        <RowContent title="언어생산성" titleRatio={1.2} childrenRatio={10.8}>
          <CheckboxOne
            i18nNullKey="ETC"
            disabled={disabled}
            i18nKey="MSE.LANGUAGE.PRODUCTIVITY"
            values={[1, 2, 3, 4, 5]}
            defaultValue={getValues('language.productivity.checked')}
            onChange={v => {
              setValue('language.productivity.checked', v);
            }}
          />
        </RowContent>
        <RowContent title="속도" titleRatio={1.2} childrenRatio={10.8}>
          <CheckboxOne
            i18nNullKey="ETC"
            disabled={disabled}
            i18nKey="MSE.LANGUAGE.SPEED"
            values={[1, 2, 3]}
            defaultValue={getValues('language.speed.checked')}
            onChange={v => {
              setValue('language.speed.checked', v);
            }}
          />
        </RowContent>
        <RowContent title="음의 고저" titleRatio={1.2} childrenRatio={10.8}>
          <CheckboxOne
            i18nNullKey="ETC"
            disabled={disabled}
            i18nKey="MSE.LANGUAGE.HEIGHT"
            values={[1, 2, 3]}
            defaultValue={getValues('language.height.checked')}
            onChange={v => {
              setValue('language.height.checked', v);
            }}
          />
        </RowContent>
        <RowContent title="톤" titleRatio={1.2} childrenRatio={10.8}>
          <CheckboxOne
            i18nNullKey="ETC"
            disabled={disabled}
            i18nKey="MSE.LANGUAGE.TON"
            values={[1, 2, 3, 4, 5]}
            defaultValue={getValues('language.ton.checked')}
            onChange={v => {
              setValue('language.ton.checked', v);
            }}
          />
        </RowContent>
        <RowContent title="언어장애" titleRatio={1.2} childrenRatio={10.8}>
          <CheckboxOne
            i18nNullKey="ETC"
            disabled={disabled}
            i18nKey="MSE.LANGUAGE.OBSTACLE"
            values={[1, 2, 3, 4, 5]}
            defaultValue={getValues('language.obstacle.checked')}
            onChange={v => {
              setValue('language.obstacle.checked', v);
            }}
          />
        </RowContent>
      </RowContainer>
    </Fragment>
  );
};

export default Language;
